import { useEffect, useState } from "react";
import "../styles/CustomAlert.css";

function CustomAlert({ message, visible }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prevProgress + 100 / (10000 / 1000);
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [10000]);
  return (
    <>
      {visible ? (
        <div className="alert-container">
          <div className="alert-content">
            <h1 className="alert-message">{message}</h1>
            <div className="alert-progress">
              <div className="progress" style={{ width: `${progress}` }}></div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default CustomAlert;
